import { LEGAL_SOURCES } from "../engine";

const sources = [
  ["Ley Federal del Trabajo vigente", LEGAL_SOURCES.lft],
  ["Ley del Seguro Social vigente", LEGAL_SOURCES.lss],
  ["Ley del Impuesto sobre la Renta vigente", LEGAL_SOURCES.lisr],
  ["Anexo 8 de la RMF 2026", LEGAL_SOURCES.annex8],
  ["Anexo 8 de la RMF 2025", LEGAL_SOURCES.annex8_2025],
  ["Anexo 8 de la RMF 2024", LEGAL_SOURCES.annex8_2024],
  ["Decreto de subsidio para el empleo 2026", LEGAL_SOURCES.subsidy],
  ["UMA 2026 — INEGI", LEGAL_SOURCES.uma],
  ["Salarios mínimos 2026 — CONASAMI", LEGAL_SOURCES.minimumWage],
  ["SUA — IMSS", LEGAL_SOURCES.sua],
];

export function MethodologyPage() {
  return (
    <article className="legal-page methodology">
      <span className="eyebrow">Transparencia de cálculo</span>
      <h1>Metodología y fuentes</h1>
      <p>
        Cada resultado conserva la versión de reglas utilizada. La matriz actual
        admite pagos de 2024 a 2026 y distingue cada vigencia de salario
        mínimo, UMA, subsidio para el empleo, cuotas de cesantía y vejez, ISR y
        la reforma de jornada y tiempo extraordinario del 1 de mayo de 2026.
      </p>
      <div className="methodology-grid">
        <section>
          <h2>Nómina</h2>
          <p>
            Convierte el salario a cuota diaria según su periodicidad; integra
            prestaciones fijas; aplica SBC mínimo y máximo, cuotas obrero
            patronales, tarifa ISR del periodo y subsidio proporcional.
          </p>
        </section>
        <section>
          <h2>Finiquito</h2>
          <p>
            Calcula salario pendiente, aguinaldo por año calendario, vacaciones
            por aniversario y prima vacacional. Los días pendientes de periodos
            completos se capturan por separado.
          </p>
        </section>
        <section>
          <h2>Liquidación</h2>
          <p>
            Mantiene separados tres meses, veinte días por año y prima de
            antigüedad. La interfaz explica cuándo un concepto no es automático.
          </p>
        </section>
        <section>
          <h2>Litigio</h2>
          <p>
            Agrega salarios vencidos hasta doce meses e intereses posteriores
            del 2% mensual sobre quince meses de salario. Se presenta como
            escenario contingente.
          </p>
        </section>
      </div>
      <h2>Fuentes primarias</h2>
      <ul className="source-list">
        {sources.map(([label, href]) => (
          <li key={href}>
            <a href={href} target="_blank" rel="noreferrer">
              {label}
            </a>
          </li>
        ))}
      </ul>
    </article>
  );
}
